<template>
  <div v-if="messages" class="change-site-version">
    <ModalComponentHeader> {{ messages?.welcome }} </ModalComponentHeader>
    <ModalComponentBody>
      <p class="change-site-version-text">
        {{ messages?.wannaChooseVersion }}
      </p>
      <DefButtonSecondary @click="handlerGetSwitchVersionLink">{{
        messages?.switchVersion
      }}</DefButtonSecondary>
      <DefButtonPrimary @click="modal.hide">{{ messages?.stayOnCurrentVersion }}</DefButtonPrimary>
    </ModalComponentBody>
  </div>
</template>

<script lang="ts" setup>
import ModalComponentHeader from '@use/useModal/ModalComponentHeader.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import { computed, onBeforeUnmount } from 'vue';
import useModal from '@use/useModal/useModal';
import { setCookie } from '@/utils/cookies';
import { useResultsStore } from '@/storePinia/stores/results';
import useLoader from '@use/useLoader/useLoader';

const modal = useModal();
const resultsStore = useResultsStore();
const siteSettings = computed(() => resultsStore.siteSettings);
const messages = computed(() => resultsStore.siteSettings?.messages);
const getHttpStatusCodeByUrl = computed(
  () => resultsStore?.routes?.siteSettings?.getHttpStatusCodeByUrl
);
const loader = useLoader();

const handlerGetSwitchVersionLink = async () => {
  const { switchVersionLink, switchVersionIndexLink } = siteSettings?.value;
  /** @see https://sova-jewels.atlassian.net/browse/SOVA-720 */
  if (switchVersionLink) {
    try {
      loader.start();
      const { path, action } = getHttpStatusCodeByUrl.value;
      const statusResponse = await axios.post(path, {
        action,
        url: siteSettings.value?.switchVersionLink,
      });
      const { code } = statusResponse.data;
      window.location.href = code == 200 ? switchVersionLink : switchVersionIndexLink;
    } catch (err) {
      console.error(err);
    } finally {
      loader.stop();
    }
  }
};
onBeforeUnmount(() => {
  setCookie('WebsiteVersionModalShowed', 'true');
});
</script>

<style lang="scss" scoped>
.change-site-version {
  text-align: center;
  :deep(.modal-component-body) {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }
  :deep(.def-button-secondary) {
    margin-bottom: 12px;
  }
}
.change-site-version-text {
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  margin-bottom: 16px;
  color: var(--color-dark-grey);
}
</style>
